import { createApp, defineCustomElement } from 'vue'
import CheckoutApp from './apps/checkout/Checkout.vue'
import {apiFetch, i18n} from "@/libs/wordpress.facade";

declare global{
	interface Window{
		wp_base_url?: string;
		itlp_env?: string;
		debug_username?: string; // used for debug from local
		itlp_checkout_params?: {
			cart_url: string;
			country_locale: string;
			countries: string;
			shipping_countries: string;
			country_states: string;
		};
		itlp_websocket_config?: {lang?: string};
		itlp_checkout_locale_data?: Record<string, string[]>;
		gtm4wp_push_ecommerce?: (event_name: string, items: any[], extra_params?: Record<string, unknown>, event_callback?: boolean, event_timeout?: number) => void;
		gtm4wp_checkout_products?: any[];
		gtm4wp_currency?: string;
		gtm4wp_checkout_value?: number;
	}
}

if(window.wp_base_url) apiFetch.use(apiFetch.createRootURLMiddleware(window.wp_base_url+'/wp-json/'));

if(window.itlp_checkout_locale_data) i18n.setLocaleData(window.itlp_checkout_locale_data, 'italpreziosi')

//createApp(CheckoutApp).mount('#itlp-checkout-app');

customElements.define('itlp-checkout-app', defineCustomElement(CheckoutApp, {shadowRoot: false}));